export const SITE = {
  name: "Umaku Sushi",
  domain: "https://umakusushi.com",
  language: "id",
  tagline: "Kedai sushi Jepang halal dengan sashimi potongan tebal khas Jabodetabek.",
  instagram: "https://www.instagram.com/umakusushi/",
  instagramHandle: "@umakusushi",
  whatsappBintaro: "https://wa.me/6281212123153",
  whatsappDisplay: "0812-1212-3153",
  ogImage: "https://umakusushi.com/images/og-image.jpg",
};

export const HOURS = {
  days: "Selasa – Minggu",
  time: "11.00 – 22.00 WIB",
  closed: "Senin tutup",
  summary: "Selasa–Minggu 11.00–22.00 WIB · Senin tutup",
};

export const NAV = [
  { label: "Beranda", to: "/", testId: "nav-link-home" },
  { label: "Menu", to: "/menu/", testId: "nav-link-menu" },
  { label: "Lokasi", to: "/lokasi/", testId: "nav-link-locations" },
  { label: "Tentang", to: "/tentang/", testId: "nav-link-about" },
  { label: "Kontak & FAQ", to: "/kontak/", testId: "nav-link-contact" },
];

export const BRANCHES = [
  {
    id: "bintaro",
    name: "Umaku Sushi Bintaro",
    area: "Bintaro Sektor 7",
    city: "Tangerang Selatan, Banten",
    address: "Ruko Sentra Menteng Blok MN No. 1, Bintaro Sektor 7, Pondok Aren, Tangerang Selatan, Banten",
    mapsUrl: "https://www.google.com/maps/search/?api=1&query=Umaku%20Sushi%20Bintaro",
    whatsapp: SITE.whatsappBintaro,
    note: "Menyediakan menu ramen. Menerima waiting list via WhatsApp saat ramai.",
    region: "Banten",
    locality: "Tangerang Selatan",
    street: "Ruko Sentra Menteng Blok MN No. 1, Bintaro Sektor 7",
  },
  {
    id: "citra-grand",
    name: "Umaku Sushi Citra Grand",
    area: "Citra Grand, Cibubur",
    city: "Bekasi, Jawa Barat",
    address: "Ruko City Walk Blok CW1 No. 26, Citra Grand, Jl. Raya Alternatif Cibubur, Jatisampurna, Bekasi, Jawa Barat",
    mapsUrl: "https://www.google.com/maps/search/?api=1&query=Umaku%20Sushi%20Citra%20Grand%20Cibubur",
    whatsapp: null,
    note: null,
    region: "Jawa Barat",
    locality: "Bekasi",
    street: "Ruko City Walk Blok CW1 No. 26, Citra Grand, Jl. Raya Alternatif Cibubur",
  },
  {
    id: "kota-wisata",
    name: "Umaku Sushi Kota Wisata",
    area: "Kota Wisata Cibubur",
    city: "Kabupaten Bogor, Jawa Barat",
    address: "Kawasan Kota Wisata Cibubur, Ciangsana, Kabupaten Bogor, Jawa Barat",
    mapsUrl: "https://www.google.com/maps/search/?api=1&query=Umaku%20Sushi%20Kota%20Wisata%20Cibubur",
    whatsapp: null,
    note: "Cek Google Maps atau Instagram untuk detail blok terbaru.",
    region: "Jawa Barat",
    locality: "Kabupaten Bogor",
    street: "Kawasan Kota Wisata Cibubur",
  },
  {
    id: "mampang",
    name: "Umaku Sushi Mampang",
    area: "Mampang Prapatan",
    city: "Jakarta Selatan, DKI Jakarta",
    address: "Jl. Mampang Prapatan Raya No. 73, Jakarta Selatan, DKI Jakarta",
    mapsUrl: "https://www.google.com/maps/search/?api=1&query=Umaku%20Sushi%20Mampang",
    whatsapp: null,
    note: "Cabang terbaru — cek Instagram @umakusushi untuk info operasional terkini.",
    isNew: true,
    region: "DKI Jakarta",
    locality: "Jakarta Selatan",
    street: "Jl. Mampang Prapatan Raya No. 73",
  },
];

export const SIGNATURES = [
  {
    name: "Sake Salmon Sashimi",
    jp: "サーモン刺身",
    desc: "Salmon segar kualitas premium dengan potongan tebal khas Umaku — favorit pelanggan sejak lama.",
    tag: "Favorit",
  },
  {
    name: "Crunchy Salmon Roll",
    jp: "クランチロール",
    desc: "Roll klasik berbalut nori berisi salmon dengan taburan renyah yang memperkaya tekstur.",
    tag: null,
  },
  {
    name: "Volcano Roll",
    jp: "ボルケーノロール",
    desc: "Perpaduan salmon panggang, mayones creamy, dan wakame — pilihan tepat pencinta rasa fusion.",
    tag: "Fusion",
  },
  {
    name: "Salmon Chizu Roll",
    jp: "サーモンチーズ",
    desc: "Potongan salmon besar berbalut nasi sushi dengan lapisan keju yang meleleh di luar.",
    tag: "Fusion",
  },
  {
    name: "Salmon Temari Aburi",
    jp: "てまり炙り",
    desc: "Irisan salmon aburi di atas nasi temari mungil, disajikan dengan saus homemade.",
    tag: null,
  },
  {
    name: "Gekikara Hotto Ramen",
    jp: "激辛ラーメン",
    desc: "Ramen kuah pedas kaya rasa dengan topping wakame, menma, ajitama, roasted beef, dan kikurage.",
    tag: "Pedas · Khusus Bintaro",
  },
];

export const MENU_CATEGORIES = [
  {
    id: "sashimi",
    jp: "刺身",
    title: "Sashimi & Salmon Special",
    desc: "Irisan ikan segar dengan potongan tebal khas Umaku.",
    items: [
      { name: "Sake Salmon Sashimi", desc: "Salmon premium diiris tebal, disajikan dingin dan segar.", tag: "Favorit" },
      { name: "Salmon Temari Aburi", desc: "Salmon aburi di atas nasi temari dengan saus homemade.", tag: null },
      { name: "Scallop Grill Tobiko", desc: "Scallop panggang dengan taburan tobiko.", tag: null },
    ],
  },
  {
    id: "roll",
    jp: "巻物",
    title: "Signature Roll",
    desc: "Roll klasik hingga fusion dengan isian melimpah.",
    items: [
      { name: "Crunchy Salmon Roll", desc: "Salmon dan taburan renyah dalam balutan nori.", tag: null },
      { name: "Volcano Roll", desc: "Salmon panggang, mayones creamy, dan wakame.", tag: "Fusion" },
      { name: "Salmon Chizu Roll", desc: "Salmon besar dengan lelehan keju di luar.", tag: "Fusion" },
    ],
  },
  {
    id: "ramen",
    jp: "拉麺",
    title: "Ramen & Mi",
    desc: "Semangkuk kehangatan dengan kuah kaya umami.",
    items: [
      { name: "Gekikara Hotto Ramen", desc: "Kuah pedas dengan wakame, menma, ajitama, roasted beef, dan kikurage.", tag: "Pedas · Khusus Bintaro" },
    ],
    footnote: "Menu ramen tersedia di cabang Bintaro.",
  },
  {
    id: "donburi",
    jp: "丼",
    title: "Donburi & Nasi",
    desc: "Aneka rice bowl ala Jepang dengan topping melimpah.",
    items: [],
    footnote: "Pilihan donburi mengikuti ketersediaan di tiap cabang.",
  },
  {
    id: "appetizer",
    jp: "前菜",
    title: "Salad & Appetizer",
    desc: "Pembuka segar untuk menemani hidangan utama.",
    items: [],
    footnote: "Tanyakan pilihan salad dan appetizer hari ini kepada staf.",
  },
];

export const FAQS = [
  {
    q: "Apakah Umaku Sushi halal?",
    a: "Ya. Umaku Sushi telah bersertifikat halal dari MUI, sehingga seluruh hidangan dapat dinikmati dengan tenang.",
  },
  {
    q: "Jam berapa Umaku Sushi buka?",
    a: "Seluruh cabang buka Selasa sampai Minggu pukul 11.00–22.00 WIB. Hari Senin seluruh cabang tutup.",
  },
  {
    q: "Di mana saja cabang Umaku Sushi?",
    a: "Umaku Sushi hadir di Bintaro (Tangerang Selatan), Citra Grand Cibubur (Bekasi), Kota Wisata Cibubur (Kabupaten Bogor), dan Mampang (Jakarta Selatan). Lihat halaman Lokasi untuk alamat dan petunjuk arah.",
  },
  {
    q: "Bisakah pesan Umaku Sushi secara online?",
    a: "Bisa. Umaku Sushi tersedia di aplikasi pesan-antar seperti GrabFood dan ShopeeFood — cukup cari \"Umaku Sushi\" di aplikasi favorit Anda.",
  },
  {
    q: "Apakah perlu reservasi sebelum datang?",
    a: "Tidak wajib. Namun cabang bisa ramai di jam makan siang — cabang Bintaro menyediakan waiting list melalui WhatsApp agar kunjungan lebih nyaman.",
  },
  {
    q: "Apakah menu ramen tersedia di semua cabang?",
    a: "Menu ramen seperti Gekikara Hotto Ramen saat ini tersedia di cabang Bintaro.",
  },
];

export const ROUTES = [
  { path: "/" },
  { path: "/menu/" },
  { path: "/lokasi/" },
  { path: "/tentang/" },
  { path: "/kontak/" },
];

const SEO = {
  "/": {
    title: "Umaku Sushi — Sushi & Sashimi Halal di Jabodetabek",
    description:
      "Umaku Sushi adalah kedai sushi Jepang bersertifikat halal MUI dengan sashimi salmon potongan tebal, signature roll, dan ramen. Cabang di Bintaro, Cibubur, Bekasi, dan Jakarta Selatan.",
  },
  "/menu/": {
    title: "Menu Umaku Sushi — Sashimi, Signature Roll & Ramen",
    description:
      "Jelajahi menu Umaku Sushi: Sake Salmon Sashimi potongan tebal, Crunchy Salmon Roll, Volcano Roll, Salmon Chizu Roll, hingga Gekikara Hotto Ramen. 100% halal MUI.",
  },
  "/lokasi/": {
    title: "Lokasi & Jam Buka Umaku Sushi — Bintaro, Cibubur, Bekasi, Jakarta",
    description:
      "Kunjungi cabang Umaku Sushi di Bintaro, Citra Grand Cibubur, Kota Wisata Cibubur, dan Mampang Jakarta Selatan. Buka Selasa–Minggu 11.00–22.00 WIB, Senin tutup.",
  },
  "/tentang/": {
    title: "Tentang Umaku Sushi — Kedai Sushi Jepang Halal",
    description:
      "Kenali Umaku Sushi: kedai sushi Jepang bersertifikat halal MUI yang mengandalkan umami dari bahan segar dan potongan salmon tebal khasnya.",
  },
  "/kontak/": {
    title: "Kontak & FAQ Umaku Sushi — WhatsApp, Instagram, Jam Buka",
    description:
      "Hubungi Umaku Sushi melalui WhatsApp cabang Bintaro atau Instagram @umakusushi. Temukan jawaban seputar status halal, jam buka, cabang, dan pesan antar.",
  },
};

export function normalizePath(path) {
  if (path !== "/" && !path.endsWith("/")) return path + "/";
  return path;
}

export function seoFor(path) {
  const p = normalizePath(path);
  const seo = SEO[p] || SEO["/"];
  return { ...seo, canonical: SITE.domain + (p === "/" ? "/" : p) };
}

function openingHours() {
  return {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "11:00",
    closes: "22:00",
  };
}

function breadcrumb(path) {
  const names = { "/menu/": "Menu", "/lokasi/": "Lokasi", "/tentang/": "Tentang", "/kontak/": "Kontak & FAQ" };
  const p = normalizePath(path);
  if (p === "/") return null;
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Beranda", item: SITE.domain + "/" },
      { "@type": "ListItem", position: 2, name: names[p] || p, item: SITE.domain + p },
    ],
  };
}

export function jsonLdFor(path) {
  const p = normalizePath(path);
  const out = [];
  if (p === "/") {
    out.push({
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE.name,
      url: SITE.domain + "/",
      inLanguage: "id",
    });
    out.push({
      "@context": "https://schema.org",
      "@type": "Restaurant",
      name: SITE.name,
      url: SITE.domain + "/",
      image: SITE.ogImage,
      servesCuisine: ["Japanese", "Sushi"],
      areaServed: "Jabodetabek, Indonesia",
      sameAs: [SITE.instagram],
      openingHoursSpecification: openingHours(),
    });
  }
  if (p === "/lokasi/") {
    BRANCHES.forEach((b) => {
      const entry = {
        "@context": "https://schema.org",
        "@type": "Restaurant",
        name: b.name,
        url: SITE.domain + "/lokasi/",
        servesCuisine: ["Japanese", "Sushi"],
        sameAs: [SITE.instagram],
        address: {
          "@type": "PostalAddress",
          streetAddress: b.street,
          addressLocality: b.locality,
          addressRegion: b.region,
          addressCountry: "ID",
        },
        openingHoursSpecification: openingHours(),
      };
      if (b.whatsapp) entry.telephone = "+6281212123153";
      out.push(entry);
    });
  }
  if (p === "/kontak/") {
    out.push({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
  }
  const crumbs = breadcrumb(p);
  if (crumbs) out.push(crumbs);
  return out;
}
